import { render, staticRenderFns } from "./allDatabase.vue?vue&type=template&id=fca5dca2&scoped=true&"
import script from "./allDatabase.vue?vue&type=script&lang=js&"
export * from "./allDatabase.vue?vue&type=script&lang=js&"
import style0 from "./allDatabase.vue?vue&type=style&index=0&rel=stylesheet%2Fscss&lang=scss&"
import style1 from "./allDatabase.vue?vue&type=style&index=1&id=fca5dca2&rel=stylesheet%2Fscss&lang=scss&scoped=true&"
import style2 from "./allDatabase.vue?vue&type=style&index=2&id=fca5dca2&rel=stylesheet%2Fscss&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fca5dca2",
  null
  
)

export default component.exports